var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvents = function SvgEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 85.63,
    y1: 260.07,
    x2: 256.54,
    y2: 113.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 66.83,
    y1: 238.13,
    x2: 237.74,
    y2: 91.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.23,
    y1: 155.2,
    x2: 166.69,
    y2: 8.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.6,
    y1: 162,
    x2: 172.52,
    y2: 15.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 13.95,
    y1: 176.41,
    x2: 184.87,
    y2: 29.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -19.57,
    y1: 137.29,
    x2: 151.35,
    y2: -9.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -7.22,
    y1: 151.71,
    x2: 163.7,
    y2: 5.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 26.3,
    y1: 190.83,
    x2: 197.22,
    y2: 44.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 5.14,
    y1: 166.13,
    x2: 176.05,
    y2: 19.68,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M165.62,193.75h-12.5c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.12,3.13,3.12h12.5c1.73,0,3.13-1.4,3.13-3.12s-1.4-3.13-3.13-3.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.67,171.49l-3.66-3.66c-2.23-2.23-3.5-5.31-3.5-8.46v-18.75c0-12.22-7.84-22.61-18.75-26.48v-4.77c0-5.17-4.21-9.37-9.38-9.37s-9.37,4.2-9.37,9.37v4.77c-10.91,3.87-18.75,14.26-18.75,26.48v18.75c0,3.15-1.27,6.23-3.5,8.46l-3.66,3.66c-3.39,3.39-5.34,8.09-5.34,12.88,0,1.73,1.4,3.12,3.13,3.12h12.5c1.73,0,3.13-1.4,3.13-3.12s-1.4-3.12-3.13-3.12h-8.95c.54-2,1.6-3.86,3.08-5.34l3.66-3.66c3.39-3.39,5.33-8.08,5.33-12.88v-18.75c0-12.06,9.81-21.87,21.87-21.87s21.88,9.81,21.88,21.87v18.75c0,4.79,1.95,9.49,5.34,12.88l3.66,3.66c1.48,1.48,2.54,3.33,3.08,5.34h-46.45c-1.73,0-3.13,1.4-3.13,3.12s1.4,3.12,3.13,3.12h50c1.73,0,3.13-1.4,3.13-3.12,0-4.79-1.94-9.49-5.33-12.88ZM162.5,112.69c-1.03-.11-2.07-.18-3.13-.18s-2.1.07-3.12.18v-3.31c0-1.72,1.4-3.12,3.12-3.12s3.13,1.4,3.13,3.12v3.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.37,175H15.62c-5.17,0-9.37-4.21-9.37-9.37V62.5h134.37c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H6.25v-21.88c0-5.17,4.2-9.37,9.37-9.37h12.5v6.25c0,6.89,5.6,12.5,12.5,12.5h6.25c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.13-3.12-3.13h-6.25c-3.45,0-6.25-2.81-6.25-6.25V12.5c0-3.45,2.81-6.25,6.25-6.25s6.25,2.8,6.25,6.25v6.25h-3.12c-1.73,0-3.13,1.4-3.13,3.12s1.4,3.13,3.13,3.13h65.62v6.25c0,6.89,5.61,12.5,12.5,12.5h6.25c1.73,0,3.13-1.4,3.13-3.12s-1.4-3.13-3.13-3.13h-6.25c-3.45,0-6.25-2.81-6.25-6.25V12.5c0-3.45,2.81-6.25,6.25-6.25s6.25,2.8,6.25,6.25v6.25h-3.12c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.13,3.12,3.13h21.88c5.17,0,9.37,4.2,9.37,9.37v56.25c0,1.73,1.4,3.12,3.12,3.12s3.13-1.4,3.13-3.12v-56.25c0-8.62-7.01-15.62-15.62-15.62h-12.5v-6.25c0-6.89-5.6-12.5-12.5-12.5s-12.5,5.61-12.5,12.5v6.25h-56.25v-6.25c0-6.89-5.61-12.5-12.5-12.5s-12.5,5.61-12.5,12.5v6.25h-12.5c-8.62,0-15.62,7.01-15.62,15.62v131.25c0,8.62,7.01,15.62,15.62,15.62h93.75c1.73,0,3.12-1.4,3.12-3.13s-1.4-3.12-3.12-3.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.5,90.63h-62.5c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.13,3.12,3.13h62.5c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.12-3.13-3.12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.5,115.62h-62.5c-1.72,0-3.12,1.4-3.12,3.13s1.4,3.12,3.12,3.12h62.5c1.73,0,3.13-1.4,3.13-3.12s-1.4-3.13-3.13-3.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31.25,84.38c-5.17,0-9.37,4.2-9.37,9.37s4.21,9.38,9.37,9.38,9.37-4.21,9.37-9.38-4.2-9.37-9.37-9.37ZM31.25,96.88c-1.72,0-3.12-1.4-3.12-3.13s1.4-3.12,3.12-3.12,3.12,1.4,3.12,3.12-1.4,3.13-3.12,3.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31.25,109.37c-5.17,0-9.37,4.21-9.37,9.38s4.21,9.37,9.37,9.37,9.37-4.21,9.37-9.37-4.2-9.38-9.37-9.38ZM31.25,121.88c-1.72,0-3.12-1.4-3.12-3.12s1.4-3.13,3.12-3.13,3.12,1.4,3.12,3.13-1.4,3.12-3.12,3.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.5,140.62h-62.5c-1.72,0-3.12,1.4-3.12,3.13s1.4,3.12,3.12,3.12h62.5c1.73,0,3.13-1.4,3.13-3.12s-1.4-3.13-3.13-3.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.25,134.38c-5.17,0-9.37,4.2-9.37,9.37s4.21,9.37,9.37,9.37,9.37-4.21,9.37-9.37-4.2-9.37-9.37-9.37ZM31.25,146.87c-1.72,0-3.12-1.4-3.12-3.12s1.4-3.13,3.12-3.13,3.12,1.4,3.12,3.13-1.4,3.12-3.12,3.12Z"
  })));
};
export default SvgEvents;